import React from "react";
import { Chip } from "@mui/material";

interface StateBadgeProps {
  stateId: number;
  label?: string;
}

const STATE_CONFIG: Record<number, { label: string; color: "success" | "error" | "warning" | "info" | "default" }> = {
  1: { label: "New", color: "info" },
  2: { label: "Open", color: "warning" },
  3: { label: "Pending Reminder", color: "warning" },
  4: { label: "Closed", color: "success" },
  5: { label: "Merged", color: "default" },
  6: { label: "Pending Close", color: "warning" },
};

const StateBadge: React.FC<StateBadgeProps> = ({ stateId, label }) => {
  const config = STATE_CONFIG[stateId] || { label: label || "Unknown", color: "default" as const };
  return (
    <Chip
      label={label || config.label}
      color={config.color}
      size="small"
      variant="outlined"
    />
  );
};

export default StateBadge;
